// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dm-mobile .dm-card-tabs {
    height: calc(100% - 83px);
}

.dm-card-toolbar {
    bottom: 0;
    left: 0;
    position: absolute !important;
    right: 0;
}

.dm-mobile-tabs {
    width: 100%;
}

.k-button.questionApprove, .k-button.questionCancel {
    height: 40px !important;
    width: 78px !important;
    background: #EBF1F4;
    border: 0.5px solid #EBF1F4;
}

.k-button.questionApprove {
    margin-right: 8px;
    margin-left: 8px;
}

.k-button.k-state-active.questionApprove {
    background: #E3F2DA;
    border: 0.5px solid #4FC127;
}

.k-button.k-state-active.questionCancel {
    background: #EEE1E1;
    border: 0.5px solid #9A2323;
}

.dm-card-value .badge, .dm-card-badge .badge {
    margin-left: 4px;
}

.k-button.addEvent {
    display: block;
    width: 100%;
    margin: 0 0 5px 0;
}

.k-button.eventClose {
    width: 38px;
    height: 38px;
    display: block;
}

.dm-container.eventContainer {
    width: calc(100% - 38px);
}

.moodIndicator.k-picker-md .k-input-inner {
    padding: 0 0 0 10px;
}

.moodIndicatorDrop svg {
    height: 35px;
    margin: 0 5px 0 0;
    width: 35px;
}

.moodIndicatorDrop .dm-wrapper-content { overflow: hidden; }`, "",{"version":3,"sources":["webpack://./ClientApp/styles/css/cardStyles.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,OAAO;IACP,6BAA6B;IAC7B,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;AAEA,yCAAyC,gBAAgB,EAAE","sourcesContent":[".dm-mobile .dm-card-tabs {\r\n    height: calc(100% - 83px);\r\n}\r\n\r\n.dm-card-toolbar {\r\n    bottom: 0;\r\n    left: 0;\r\n    position: absolute !important;\r\n    right: 0;\r\n}\r\n\r\n.dm-mobile-tabs {\r\n    width: 100%;\r\n}\r\n\r\n.k-button.questionApprove, .k-button.questionCancel {\r\n    height: 40px !important;\r\n    width: 78px !important;\r\n    background: #EBF1F4;\r\n    border: 0.5px solid #EBF1F4;\r\n}\r\n\r\n.k-button.questionApprove {\r\n    margin-right: 8px;\r\n    margin-left: 8px;\r\n}\r\n\r\n.k-button.k-state-active.questionApprove {\r\n    background: #E3F2DA;\r\n    border: 0.5px solid #4FC127;\r\n}\r\n\r\n.k-button.k-state-active.questionCancel {\r\n    background: #EEE1E1;\r\n    border: 0.5px solid #9A2323;\r\n}\r\n\r\n.dm-card-value .badge, .dm-card-badge .badge {\r\n    margin-left: 4px;\r\n}\r\n\r\n.k-button.addEvent {\r\n    display: block;\r\n    width: 100%;\r\n    margin: 0 0 5px 0;\r\n}\r\n\r\n.k-button.eventClose {\r\n    width: 38px;\r\n    height: 38px;\r\n    display: block;\r\n}\r\n\r\n.dm-container.eventContainer {\r\n    width: calc(100% - 38px);\r\n}\r\n\r\n.moodIndicator.k-picker-md .k-input-inner {\r\n    padding: 0 0 0 10px;\r\n}\r\n\r\n.moodIndicatorDrop svg {\r\n    height: 35px;\r\n    margin: 0 5px 0 0;\r\n    width: 35px;\r\n}\r\n\r\n.moodIndicatorDrop .dm-wrapper-content { overflow: hidden; }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
